import heroIMG from '../../assets/images/projects/craftoria/hero.png';
import challengeIMG from '../../assets/images/projects/craftoria/challenge.png';
import structureIMG from '../../assets/images/projects/craftoria/structure.png';

import { projectAuthorData } from './projectAuthorData';

export const craftoriaProject = {
    id: 6,
    slug: 'craftoria',

    label: 'Shopify',
    category: 'Shopify Anpassung',

    title: 'Craftoria Creative',

    cardDescription:
        'Shopify-Umsetzung für kreative Produkte mit klaren Kategorien, mobiler Darstellung und technischer Theme-Anpassung.',

    image: heroIMG,
    imageAlt: 'Craftoria Creative Shopify Store Startseite',

    tags: ['UX/UI', 'Entwicklung', 'Shopify'],

    website: 'https://craftoriashop.pl/',

    page: {
        seo: {
            title: 'Craftoria Creative — Shopify-Umsetzung für einen DIY- und Kreativbedarf Store | Nexon Digital Studio',

            description:
                'Shopify-Umsetzung für Craftoria Creative mit Produktkategorien, mobiler Optimierung, visueller Produktpräsentation und flexibler Store-Struktur.',
        },

        hero: {
            subtitle:
                'Nexon Digital Studio entwickelt und verbessert Shopify-Shops für kleine Unternehmen, Marken und Online-Händler in Deutschland — klar strukturiert, technisch sauber und auf Online-Verkauf ausgerichtet.',

            title: ['SHOPIFY', 'ENTWICKLUNG'],

            text: 'Shopify-Erstellung, Theme-Anpassung, Relaunch und technische Umsetzung für Unternehmen, die online verkaufen möchten.',

            button: 'Anfrage senden',
        },

        intro: {
            title: 'Craftoria Creative — Shopify-Umsetzung für einen DIY- und Kreativbedarf Store',

            texts: [
                'Für Craftoria Creative wurde ein Shopify-Store für DIY-Produkte, Kerzenbedarf, Malmaterialien und kreative Sets technisch umgesetzt und strukturiert aufgebaut. Der Fokus lag auf klaren Produktkategorien, übersichtlichen Collections, mobiler Darstellung und einer sauberen technischen Grundlage für den Online-Verkauf.',

                'Das Projekt zeigt, wie Nexon Digital Studio Shopify-Shops mit vielen Produktgruppen, Kategorien und kreativen Produktwelten technisch unterstützt, verständlicher strukturiert und für Kunden besser nutzbar macht.',
            ],

            meta: [
                {
                    id: 1,
                    title: 'Shopify Store',
                    label: 'Projektart',
                },
                {
                    id: 2,
                    title: 'DIY & Kreativbedarf',
                    label: 'Branche',
                },
                {
                    id: 3,
                    title: 'Kategorien',
                    label: 'Umfang',
                },
                {
                    id: 4,
                    title: 'Mobile Darstellung',
                    label: 'Fokus',
                },
            ],

            image: heroIMG,
            imageAlt: 'Craftoria Creative Shopify Store Startseite',
        },

        challenge: {
            theme: 'dark',

            eyebrow: 'Ausgangssituation',

            title: 'Ein Shopify-Store mit vielen kreativen Produktkategorien.',

            text: 'Craftoria Creative verkauft Produkte rund um Kerzen, DIY, Malen, kreative Sets, Modellieren und Zubehör. Der Shopify-Store musste viele Kategorien, Unterkategorien und Produktbereiche verständlich abbilden, damit Kunden schneller passende Materialien, Sets und Zubehör finden können.',

            items: [
                {
                    id: 1,
                    text: 'Viele Produktkategorien und Unterkategorien mussten klar strukturiert werden',
                },
                {
                    id: 2,
                    text: 'Bereiche wie Kerzenbedarf, Malen, kreative Sets und Modellieren sollten verständlich auffindbar sein',
                },
                {
                    id: 3,
                    text: 'Produktseiten und Collection-Bereiche mussten auch bei vielen Artikeln übersichtlich bleiben',
                },
                {
                    id: 4,
                    text: 'Mobile Darstellung und Navigation sollten den Einkauf auf Smartphones erleichtern',
                },
                {
                    id: 5,
                    text: 'Startseite und Kategorie-Bereiche mussten stärker auf Orientierung und Online-Verkauf ausgerichtet werden',
                },
                {
                    id: 6,
                    text: 'Der Store brauchte eine technische Grundlage für weitere Produkte, Inhalte und Aktionen',
                },
            ],

            image: challengeIMG,
            imageAlt: 'Craftoria Creative Produktbereich Shopify',
        },

        structure: {
            theme: 'light',

            eyebrow: 'Zielsetzung',

            title: 'Eine klare Shopify-Struktur für kreative Produktwelten schaffen.',

            text: 'Ziel des Projekts war es, den Craftoria Creative Shopify-Store klarer, nutzbarer und technisch sauber aufzubauen. Besonders wichtig waren eine verständliche Kategorie-Struktur, übersichtliche Collections, mobile Darstellung und eine technische Grundlage, die weitere Produkte, Inhalte und Kampagnen unterstützt.',

            image: structureIMG,
            imageAlt: 'Craftoria Creative Mobile Shopify Store',

            items: [
                {
                    id: 1,
                    title: 'Kategorie-Struktur',
                    text: 'DIY-Produkte, Kerzenbedarf, Malmaterialien, Sets und Zubehör sollten klar organisiert werden, damit Kunden schneller passende Bereiche finden.',
                },
                {
                    id: 2,
                    title: 'Produktbereiche',
                    text: 'Collection-Seiten und Produktbereiche wurden auf bessere Orientierung, verständliche Präsentation und einfachere Nutzerführung ausgerichtet.',
                },
                {
                    id: 3,
                    title: 'Mobile Darstellung',
                    text: 'Der Shopify-Store sollte auch auf Smartphones klar funktionieren und Produktkategorien übersichtlich darstellen.',
                },
                {
                    id: 4,
                    title: 'Technische Grundlage',
                    text: 'Shopify-Anpassungen wurden so umgesetzt, dass Kategorien, Produkte und Inhalte langfristig gepflegt und erweitert werden können.',
                },
            ],
        },

        shopifyImplementation: {
            theme: 'dark',

            eyebrow: 'Warum Nexon Digital Studio',

            title: 'Fokussierte Shopify-Umsetzung für Shops mit vielen Kategorien.',

            text: 'Für Craftoria Creative lag der Fokus auf einer Shopify-Umsetzung, die viele Produktgruppen, Collections und kreative Kategorien übersichtlich abbildet. Nexon Digital Studio unterstützte bei Store-Struktur, Produktpräsentation, mobiler Darstellung und technischen Anpassungen für den Online-Verkauf.',

            items: [
                {
                    id: 1,
                    title: 'Shopify-Expertise',
                    text: 'Technische Umsetzung von Shopify-Stores, Produktseiten, Collections und Theme-Anpassungen.',
                },
                {
                    id: 2,
                    title: 'Klare Produktstruktur',
                    text: 'Strukturierung von Produktgruppen, Unterkategorien und Collections für eine bessere Nutzerführung.',
                },
                {
                    id: 3,
                    title: 'Saubere Store-Umsetzung',
                    text: 'Technische Anpassungen am Shopify-Store, damit Produkte, Inhalte und Verkaufsbereiche langfristig pflegbar bleiben.',
                },
            ],
        },

        implementation: {
            theme: 'light',

            eyebrow: 'Umsetzung',

            title: 'Kategorien, Produktbereiche und mobile Darstellung technisch umgesetzt.',

            items: [
                {
                    id: 1,
                    eyebrow: 'Shopify Store',
                    title: 'Startseite und Kategorie-Bereiche',
                    text: 'Zentrale Bereiche des Shopify-Stores wurden technisch umgesetzt und klar auf Produktpräsentation, Orientierung und Online-Verkauf ausgerichtet.',
                },
                {
                    id: 2,
                    eyebrow: 'Collections & Kategorien',
                    title: 'Übersichtliche Produktwelten',
                    text: 'Produktgruppen und Collection-Seiten wurden so strukturiert, dass Kunden schneller relevante Materialien, Sets und Zubehör finden.',
                },
                {
                    id: 3,
                    eyebrow: 'Mobile Optimierung',
                    title: 'Nutzbar auf allen Geräten',
                    text: 'Mobile Darstellung, Navigation und Nutzerführung wurden geprüft und angepasst, damit der Shopify-Store auch auf Smartphones verständlich nutzbar bleibt.',
                },
            ],
        },

        results: {
            theme: 'light',

            eyebrow: 'Ergebnisse',

            title: 'Ein klar strukturierter Shopify-Store für DIY- und Kreativbedarf',

            stats: [
                {
                    id: 1,
                    value: '10+',
                    label: 'Store-Bereiche',
                    text: 'Strukturiert und technisch umgesetzt',
                },
                {
                    id: 2,
                    value: '5+',
                    label: 'Hauptbereiche',
                    text: 'Kerzenbedarf, Malen, Sets, Modellieren und Zubehör',
                },
                {
                    id: 3,
                    value: '3',
                    label: 'Breakpoints',
                    text: 'Desktop, Tablet und Mobile geprüft',
                },
                {
                    id: 4,
                    value: '100%',
                    label: 'Shopify',
                    text: 'Produktstruktur, Store-Aufbau und technische Umsetzung',
                },
            ],

            testimonial: {
                quote: 'Bei diesem Projekt lag der Fokus darauf, einen Shopify-Store mit vielen kreativen Produktbereichen verständlicher zu strukturieren. Besonders wichtig waren klare Kategorien, mobile Nutzerführung und eine technische Grundlage, die weitere Produkte, Inhalte und Aktionen sauber unterstützt.',

                labelTitle: 'Kommentar-Label:',
                label: 'Kommentar zur Umsetzung',

                author: {
                    ...projectAuthorData,
                    name: 'Dmytro Kiriachek',
                    position: 'CEO Nexon Digital Studio',
                },
            },
        },

        faq: {
            title: 'Häufige Fragen zu diesem Shopify-Projekt',

            items: [
                {
                    id: 1,
                    question: 'Was wurde bei Craftoria Creative umgesetzt?',

                    answer: 'Bei Craftoria Creative lag der Fokus auf technischer Shopify-Umsetzung, klarer Kategorie-Struktur, Produktbereichen, Collections, mobiler Darstellung und einer sauberen Store-Struktur für den Online-Verkauf.',
                },
                {
                    id: 2,
                    question: 'Für welche Unternehmen ist dieses Shopify-Projekt relevant?',

                    answer: 'Dieses Shopify-Projekt ist relevant für Online-Händler, DIY-Marken, Kreativbedarf-Shops und Unternehmen mit vielen Produktkategorien, Unterkategorien oder erklärungsbedürftigen Produkten.',
                },
                {
                    id: 3,
                    question: 'Welche Shopify-Bereiche wurden berücksichtigt?',

                    answer: 'Im Projekt wurden zentrale Shopify-Bereiche wie Startseite, Produktseiten, Kategorien, Collections, Navigation, mobile Darstellung und technische Store-Struktur berücksichtigt.',
                },
                {
                    id: 4,
                    question: 'Warum ist eine klare Kategorie-Struktur in Shopify wichtig?',

                    answer: 'Eine klare Kategorie-Struktur hilft Kunden, passende Produkte schneller zu finden. Besonders bei vielen Produktgruppen, Materialien, Sets und Zubehör ist eine verständliche Shopify-Struktur wichtig für Nutzerführung und Online-Verkauf.',
                },
                {
                    id: 5,
                    question: 'Kann Nexon Digital Studio ähnliche Shopify-Stores umsetzen?',

                    answer: 'Ja. Nexon Digital Studio unterstützt kleine Unternehmen, Marken und Online-Händler bei Shopify-Umsetzung, Theme-Anpassung, Produktseiten, Collections, mobiler Optimierung und technischer Store-Struktur.',
                },
                {
                    id: 6,
                    question: 'Unterstützt Nexon Digital Studio auch bestehende Shopify-Stores?',

                    answer: 'Ja. Bestehende Shopify-Stores können technisch angepasst, neu strukturiert oder für mobile Nutzung, Produktpräsentation und bessere Pflege im Shopify-Admin verbessert werden.',
                },
            ],

            button: {
                text: 'Anfrage senden',
                href: '#contacts',
            },
        },
    },
};
